<template>
  <div class="container">
    <div class="mobile-head">
      <div class="logo">
        <img src="@/assets/img/logo1.jpg" />
        MARAGON CONSTRUCCIÓN
      </div>

      <div class="mobile-mune">
        <!-- 语言切换 -->
        <!-- <el-link :underline="false" class="lang" @click="changeLang">{{
          $t("lang")
        }}</el-link> -->
        <img src="@/assets/img/menu_tab.svg" @click="changeMune" />
      </div>
    </div>
    <div v-show="isOpen" class="mobile-aside">
      <div class="close">
        <i class="el-icon-close" @click="changeMune"></i>
      </div>
      <base-aside mode="vertical" :active="$route.path" :routers="routerList">
      </base-aside>
    </div>

    <div
      class="head"
      :class="{
        sticky: scrollHeight > 0,
      }"
    >
      <base-head>
        <h1 class="logo" slot="logo">
          <img src="@/assets/img/logo1.jpg" />
          MARAGON CONSTRUCCIÓN
        </h1>

        <div slot="header-right" class="mune">
          <base-aside :active="$route.path" ref="aside" :routers="routerList">
            <!-- <router-link class="collapse">
              <i class="el-icon-s-fold"></i>
            </router-link> -->
          </base-aside>
          <!-- <el-link :underline="false">
            <i class="search el-icon-search"></i
          ></el-link> -->
        </div>
      </base-head>
    </div>
    <el-container class="content" direction="horizontal">
      <el-container>
        <el-main class="main">
          <slot>
            <router-view
              :scrollHeight="scrollHeight"
              :key="$route.path"
            ></router-view>
          </slot>
        </el-main>
      </el-container>
    </el-container>
    <template>
      <!-- <breadcrumb
        v-if="$route.path != '/' && $route.name != '404'"
        :matcheds="matcheds"
      /> -->
      <Footer />
      <mobile-footer :routers="routerList" />
    </template>
  </div>
</template>

<script>
import baseHead from "./header"
import baseAside from "./aside"
import Footer from "./footer"
import mobileFooter from "./mobileFooter"
// import breadcrumb from "./breadcrumb"

export default {
  name: "layout-index",
  props: {
    scrollHeight: Number,
  },
  components: {
    baseHead,
    baseAside,
    Footer,
    // breadcrumb,
    mobileFooter,
  },
  data() {
    return {
      routerList: {},
      matcheds: [],
      isOpen: false,
    }
  },
  computed: {},
  watch: {},
  created() {
    let user = sessionStorage.getItem("user")
    if (user) {
      this.user = JSON.parse(user)
    }
  },
  mounted() {
    // this.user = JSON.parse(sessionStorage.getItem("user"));
    let router = this.$router
    let options = router.options.routes[0]
    this.routerList = { url: options.path, menus: options.children }
    this.matcheds = this.$route.matched
    document.body.style.overflow = "visible"
  },
  methods: {
    changeMune() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        document.body.style.overflow = "hidden"
      } else {
        document.body.style.overflow = "visible"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb + .el-main {
  padding: 0px $--padding $--padding $--padding;
}

@keyframes zoom {
  0% {
    transform: scale(1); /* 初始状态，图片原始大小 */
  }

  100% {
    transform: scale(1.1); /* 结束状态，图片放大到1.2倍 */
  }
}
@keyframes translateX {
  0% {
    transform: translateX(-100%); /* 初始状态，图片原始大小 */
  }

  100% {
    opacity: 1;
    transform: translateX(0); /* 结束状态，图片放大到1.2倍 */
  }
}
.container {
  .el-container {
    display: block;
  }
  .head {
    position: absolute;
    top: 0px;
    width: 100%;
    z-index: 1000;
    &.sticky {
      position: sticky;
      .header {
        background: #fff;
        box-shadow: 0px 5px 9px 1px rgba(56, 51, 117, 0.15);
        z-index: 100;
        padding-top: 10px;
        padding-bottom: 10px;
        &.white ::v-deep .logo,
        &.white ::v-deep .title,
        &.white ::v-deep .search {
          color: #000;
        }
        .logo {
          font-size: calc(var(--font-size) - 10px);
          img {
            width: 100px;
            height: 100px;
          }
        }
        ::v-deep .title {
          font-size: calc(var(--font-size) - 10px);
        }
      }
    }
    ::v-deep .el-menu .el-menu-item {
      padding-left: 33px !important;
      padding-right: 33px !important;
    }

    .submenu-full {
      background: #f5f5f5;
      box-shadow: 0px 5px 9px 1px rgba(56, 51, 117, 0.15);
      position: absolute;
      top: 0;
      left: 0px;
      width: 100%;
    }
  }
  .header {
    position: absolute;
    height: 100%;
    width: var(--page-width);
    ::v-deep .header-left {
      display: flex;
      align-items: center;
    }
    .logo {
      display: flex;
      align-items: center;
      font-size: calc(var(--font-size) - 4px);
    }
    img {
      margin-right: 6px;
      width: 170px;
      height: 170px;
      object-fit: contain;
    }
  }

  .mune {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .search {
      margin-left: 33px;
    }
    .tools {
      ::v-deep {
        .el-dropdown-link,
        .router-link--inner {
          color: $--color-primary;
        }
      }
    }
  }

  .content {
    min-height: 100vh;
    background-color: $--background-color-base;
    margin: 0 auto;
    position: relative;
    z-index: 0;
    .main {
      padding: 0px;
      overflow: visible;
    }
  }

  .collapse {
    position: absolute;
    bottom: 0px;
    right: $--margin;
    text-align: right;

    ::v-deep i {
      font-size: var(--font-size);
    }
  }
}
</style>
